module.exports = __webpack_public_path__ + "./assets/img_ntu_color@2x__493eac8ad8ef25542332220931369c4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/img_ntu_color@2x.jpg
// module id = 611
// module chunks = 12